module.exports = __webpack_public_path__ + "img/Salutaria_Project_Logo.e08da3e6.png";